import { useQuery } from '@tanstack/react-query';
import { IGetAllUsers } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

const NOT_APPROVED = "not approved";
const BLOCKED = "blocked";

const statusMap: Record<string, number> = {
  [NOT_APPROVED]: 0,
  [BLOCKED]: 1,
};

export const getAllUsers = async (searchParams: URLSearchParams) => {
  const res = await apiManager.get<IGetAllUsers>("/admin/user/all", {
    limit: 10,
    page: searchParams.get("page") || 1,
    sort: "desc",
    search: searchParams.get("search") || "",
    approved:
      searchParams.get("status") === NOT_APPROVED
        ? statusMap[NOT_APPROVED]
        : "",
    blocked: searchParams.get("status") === BLOCKED ? statusMap[BLOCKED] : "",
    searchKey: "fullName",
    fromDate: searchParams.get("fromDate") || "",
    toDate: searchParams.get("toDate") || "",
    state: searchParams.get("state") || "",
  });
  return res;
};

export const useGetAllUsers = (searchParams: URLSearchParams) =>
  useQuery({
    queryKey: ["get_all_users", searchParams.toString()],
    queryFn: async (): Promise<IGetAllUsers> => {
      const res = await apiClient.get("/admin/user/all", {
        params: {
          limit: 10,
          page: searchParams.get("page") || 1,
          sort: "desc",
          search: searchParams.get("search") || "",
          approved: searchParams.get("status") === NOT_APPROVED ? statusMap[NOT_APPROVED] : "",
          blocked: searchParams.get("status") === BLOCKED ? statusMap[BLOCKED] : "",
          searchKey: "fullName",
          fromDate: searchParams.get("fromDate") || "",
          toDate: searchParams.get("toDate") || "",
          state: searchParams.get("state") || "",
        },
      });
      return res.data;
    },
  });

export const useGetAllCombinedUsers = (searchParams: URLSearchParams) =>
  useQuery({
    queryKey: ["get_all_combined_users", searchParams.toString()],
    queryFn: async () => {
      const res = await apiClient.get("/admin/all-users", {
        params: {
          limit: 10,
          page: searchParams.get("page") || 1,
          sort: "desc",
          search: searchParams.get("search") || "",
        },
      });
      return res.data;
    },
  });
